import { notifyAnalytics } from '@/api/analytics/notifyAnalytics'
import { ALL_EV_MODELS_ENDPOINT } from '@/api/clients/charger-database-client'

/**
 * Fetches a list of all EV models from the charger database.
 *
 * @returns A list of all EV models from the charger database.
 */
export default async function fetchEVModels(): Promise<any> {
  const requestOptions = {
    method: 'GET',
  }

  const response = await fetch(ALL_EV_MODELS_ENDPOINT, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => {
      // If JSON parsing fails, rethrow the error
      if (import.meta.env.MODE === 'development') {
        console.error('Fetching chargerDB EV models failed.', error)
      } else notifyAnalytics({ type: 'log_error', data: error })
    })

  return response
}
